import { render } from "./ViewCar.vue?vue&type=template&id=04b2b511&scoped=true"
import script from "./ViewCar.vue?vue&type=script&lang=js"
export * from "./ViewCar.vue?vue&type=script&lang=js"

import "./ViewCar.vue?vue&type=style&index=0&id=04b2b511&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b2b511"]])

export default __exports__